import { CloudArrows, GitBranch, Stack, User } from "components/icons/generated";
import { INTEGRATIONS_FILTER_PATH } from "views/Account/Integrations/registry/shared/VcsShared/constants";

import { LaunchPadFeatureMetadata } from "../types";
import { LaunchPadFeatureSaaS } from "./types";

export const GET_STARTED_FEATURES: LaunchPadFeatureMetadata<LaunchPadFeatureSaaS>[] = [
  {
    feature: LaunchPadFeatureSaaS.IntegrateVCS,
    title: "Integrate Source code",
    icon: GitBranch,
    url: INTEGRATIONS_FILTER_PATH,
    analyticsTitle: "Integrate VCS Click",
  },
  {
    feature: LaunchPadFeatureSaaS.IntegrateCloud,
    title: "Integrate your cloud account",
    icon: CloudArrows,
    url: "/integrations",
    analyticsTitle: "Integrate Cloud Click",
  },
  {
    feature: LaunchPadFeatureSaaS.CreateStack,
    title: "Create first stack",
    icon: Stack,
    url: "/new/stack",
    analyticsTitle: "Create Stack Click",
  },
  {
    feature: LaunchPadFeatureSaaS.InviteTeammates,
    title: "Invite teammates",
    icon: User,
    url: "/settings/users",
    analyticsTitle: "Invite User Click",
  },
];
